import { CategoryUidaAsset, LCBatchesPresentationOrderEnum, UIDAPresentationTypeEnum, tvpil } from '../../compat/tvpil';

export type ChannelsSettings = {
  aggregatedKsql: string | undefined;
  collectionId: number | undefined;
  includeAdult: boolean;
  limit?: number;
  orderBatches?: Array<LCBatchesPresentationOrderEnum>;
};

type GetSettingsType = (category: CategoryUidaAsset) => ChannelsSettings;

export const settingsMap: Partial<Record<UIDAPresentationTypeEnum, GetSettingsType>> = {
  [UIDAPresentationTypeEnum.epg]: getEpgSettings,
  [UIDAPresentationTypeEnum.favorites]: getFavoritesSettings,
  [UIDAPresentationTypeEnum.hero]: getHeroSettings,
  [UIDAPresentationTypeEnum.personal_lineup]: getPersonalLineupSettings,
  [UIDAPresentationTypeEnum.zapper]: getZapperSettings,
};

export function getChannelsSettings(category: CategoryUidaAsset): ChannelsSettings | undefined {
  const getter = settingsMap[category.subtype];

  return getter?.(category);
}

function getEpgSettings(category: CategoryUidaAsset) {
  return {
    aggregatedKsql: category.aggregatedKSQL,
    collectionId: category.channels[0],
    includeAdult: tvpil.transactionStore.isAdultEntitled,
    orderBatches: category.epgProperty.orderBatches ?? [LCBatchesPresentationOrderEnum.lcn],
  };
}

function getFavoritesSettings(category: CategoryUidaAsset) {
  if (tvpil.rootStore.isPersonalLineupEnabled) {
    return getPersonalLineupSettings(category);
  }

  return {
    aggregatedKsql: category.aggregatedKSQL,
    collectionId: category.channels[0],
    includeAdult: false,
    orderBatches: [LCBatchesPresentationOrderEnum.fav, LCBatchesPresentationOrderEnum.lcn],
  };
}

function getHeroSettings(category: CategoryUidaAsset) {
  return {
    aggregatedKsql: category.aggregatedKSQL,
    collectionId: category.channels[0],
    includeAdult: tvpil.transactionStore.isAdultEntitled,
    limit: category.railProperty.railItemsLimit,
    orderBatches: category.epgProperty.orderBatches ?? [LCBatchesPresentationOrderEnum.lcn],
  };
}

function getPersonalLineupSettings(category: CategoryUidaAsset) {
  return {
    aggregatedKsql: category.aggregatedKSQL,
    collectionId: category.channels[0],
    includeAdult: true,
  };
}

function getZapperSettings(category: CategoryUidaAsset) {
  return {
    aggregatedKsql: category.aggregatedKSQL,
    collectionId: category.channels[0],
    includeAdult: tvpil.transactionStore.isAdultEntitled,
    orderBatches: category.epgProperty.orderBatches ?? [LCBatchesPresentationOrderEnum.lcn],
  };
}
